import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const PromoBlockDescription = props => {
  const { className, children, ...other } = props;

  return (
    <p className={clsx("em-c-promo-block__desc", className)} {...other}>
      {children}
    </p>
  );
};

PromoBlockDescription.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

PromoBlockDescription.defaultProps = {
  className: "",
  children: null
};

export default PromoBlockDescription;
